/* eslint-disable react/no-unescaped-entities */
import roadmapicon1 from "../../assets/images/all-img/v3/roadmap-icon1.png";
import roadmapicon2 from "../../assets/images/all-img/v3/roadmap-icon2.png";
import roadmapicon3 from "../../assets/images/all-img/v3/roadmap-icon3.png";
import roadmapicon4 from "../../assets/images/all-img/v3/roadmap-icon4.png";
 
export default function NftRoadMap() {
	return (
		<div className="fugu--roadmap-section">
			<div className="container">
				<div className="fugu--section-title">
					<div className="fugu--default-content content-sm">
						<h2>Create and sell your NFTs</h2>
						<p>
							Anyone can make a profile on Foundation but only selected creators can mint NFTs & published
							a complete guide.
						</p>
					</div>
				</div>
				<div className="row">
					<div className="col-xl-3 col-md-6">
						<div className="fugu--iconbox-wrap wow fadeInUpX" data-wow-delay="0s">
							<div className="fugu--iconbox-thumb">
								<img src={roadmapicon1} alt="" />
							</div>
							<div className="fugu--iconbox-data">
								<h4>Set up your wallet</h4>
								<p>
									Once you've set up your wallet of choice, connect it by clicking the wallet icon
									easily.
								</p>
							</div>
						</div>
					</div>
					<div className="col-xl-3 col-md-6">
						<div className="fugu--iconbox-wrap wow fadeInUpX" data-wow-delay="0.10s">
							<div className="fugu--iconbox-thumb">
								<img src={roadmapicon2} alt="" />
							</div>
							<div className="fugu--iconbox-data">
								<h4>Create collection</h4>
								<p>
									Click my collections and set up your collection. Add social links a description and
									others.
								</p>
							</div>
						</div>
					</div>
					<div className="col-xl-3 col-md-6">
						<div className="fugu--iconbox-wrap wow fadeInUpX" data-wow-delay="0.20s">
							<div className="fugu--iconbox-thumb">
								<img src={roadmapicon3} alt="" />
							</div>
							<div className="fugu--iconbox-data">
								<h4>Add your NFT</h4>
								<p>
									Upload your work (Image, art, video, audio, or 3D art) add a title and description.
								</p>
							</div>
						</div>
					</div>
					<div className="col-xl-3 col-md-6">
						<div className="fugu--iconbox-wrap wow fadeInUpX" data-wow-delay="0.30s">
							<div className="fugu--iconbox-thumb">
								<img src={roadmapicon4} alt="" />
							</div>
							<div className="fugu--iconbox-data">
								<h4>List them for sale</h4>
								<p>
									Choose between action, fixed-price listings & pricing listings. We help you sell
									them.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
